import { useEffect, useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import OrdersTable from 'Components/UI/Organisms/Sales/Orders'
import Create from 'Components/UI/Organisms/Sales/Orders/Create'
import ExportOrders from 'Components/UI/Organisms/Sales/Orders/Export'
import TemplateGlobal from 'Components/UI/Templates/Common'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

const OrdersTemplate = () => {
  const [render, setRender] = useState(true)
  const [dataBefore, setDataBefore] = useState()

  const [openExport, setOpenExport] = useState({ open: false, suspense: false })
  const [values, setValues] = useState({
    rows: [],
    header: [],
  })
  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()

  const closeDialogExport = () => {
    setOpenExport({ ...openExport, open: false })
  }

  const openDialogExport = () => {
    setOpenExport({ open: true, suspense: true })
  }

  async function apiCall() {
    await interfaces.salesOrders.ordersBefore().then((res) => {
      setDataBefore({
        data: res.data,
        permissions: res.data.permissions,
      })
    })
  }

  // async function apiCallData(options, callback) {
  //   const queryString = typeof options === "string"
  //       ? `${options}&origen=ECO`
  //       : `${new URLSearchParams(options).toString()}&origen=ECO`
  //   setValues({
  //       rows: [],
  //       header: [],
  //   });
  //   try {
  //       const result = await interfaces.salesOrders.ordersList(`?${queryString}`);
  //       setValues({
  //           rows: result.data,
  //           header: result.header.header.count,
  //       });
  //       callback();
  //   } catch (error) {}
  //  }
  const permissions = dataBefore?.permissions

  useEffect(() => {
    apiCall()
  }, [render])

  // useEffect(()=> {
  //   apiCallData()
  // }, [render])

  const BUTTONS = [
    {
      onClick: openDialogExport,
      menuTitle: 'Exportar',
      menuIcon: <GetAppIcon fontSize="small" />,
      buttonContent: <GetAppIcon style={{ color: 'black' }} />,
      disabled: !permissions?.allowExport,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Nuevo',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: permissions?.allowCreate ? oemColorButton(pathname, location) : {},
      disabled: !permissions?.allowCreate,
    },
  ]

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Ventas" subTitle="Pedidos" buttons={BUTTONS} />}
        table={
          <>
            <OrdersTable
              dataBefore={dataBefore}
              values={values}
              setValues={setValues}
              render={render}
              setRender={setRender}
              permissions={permissions}
            />

            {openExport.suspense && (
              <ExportOrders
                open={openExport.open}
                onClose={closeDialogExport}
                data={dataBefore.data}
              />
            )}
          </>
        }
      />
      {openNew.suspense && (
        <Create
          data={dataBefore.data}
          render={render}
          setRender={setRender}
          open={setOpenNew}
          handleClose={setCloseNew}
        />
      )}
    </div>
  )
}

export default OrdersTemplate
